"use client";

import { useRouter } from "@bprogress/next";
import { useState } from "react";
import { Search, ArrowRightIcon } from "lucide-react";
import { createPath } from "@/service/routing/routing";

export const HomeCarSearch = () => {
  const router = useRouter();
  const [value, setValue] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    const base = createPath("car_offer.index");
    const href = trimmed ? `${base}?q=${encodeURIComponent(trimmed)}` : base;
    router.push(href);
  };

  return (
    <form onSubmit={handleSubmit} className="relative flex items-center gap-2">
      <div
        className={`relative flex-1 transition-all duration-150 ${value ? "ring-2 ring-[#483A4F]/30" : ""} rounded-lg`}
      >
        <Search
          className={`absolute top-1/2 left-3.5 h-4 w-4 -translate-y-1/2 transition-colors duration-150 ${value ? "text-[#483A4F]" : "text-gray-400"}`}
        />
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Wyszukaj samochód po marce, modelu…"
          className="border-input bg-background placeholder:text-muted-foreground h-12 w-full rounded-lg border pr-4 pl-10 text-sm shadow-sm transition-[border-color,box-shadow] duration-150 focus-visible:border-[#483A4F]/50 focus-visible:ring-2 focus-visible:ring-[#483A4F]/20 focus-visible:outline-none"
        />
      </div>
      <button
        type="submit"
        className="inline-flex h-12 shrink-0 items-center gap-1.5 rounded-lg bg-zinc-900 px-5 text-[13px] font-semibold text-white transition-transform duration-150 hover:scale-[1.02] hover:cursor-pointer active:scale-[0.98]"
      >
        Szukaj
        <ArrowRightIcon className="h-3.5 w-3.5" />
      </button>
    </form>
  );
};
